// Full date + time in ONE line (existing usage)
export function formatDateTime(dateString) {
  if (!dateString) return "—";

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}


// Date & Time separated (for table with stacked UI)
export function formatDateTimeSplit(dateString) {
  if (!dateString) {
    return { date: "—", time: "" };
  }

  const date = new Date(dateString);

  return {
    date: date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    time: date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };
}
